"use client";

import { c as _c } from "react/compiler-runtime";
import { ContentBlock } from "../../ui/ContentBlock";
import { Button } from "../../ui/Button";
import type { Route } from "next";
import { barlowCondensed, roboto } from "../../../utils/fonts";
import { cn } from "@local/utils/src/cn";
import { SingleCategoryCard } from "./SingleCategoryCard";
import { CssCarousel } from "../../ui/CssCarousel";
import type { Offer } from "@local/offer/src/types";
import { ArrowTitle } from "../../ui/ArrowTitle";
import { getT } from "@local/i18n/src/t";
import { getLanguageForMarket } from "@local/i18n/src/languages";
import { category as categoryCatalog } from "@local/i18n/src/catalogs/category";
export const CategoriesListing = t0 => {
  const $ = _c(34);
  const {
    content,
    market
  } = t0;
  const {
    headline,
    ctaText,
    categories
  } = content;
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== categories || $[1] !== ctaText || $[2] !== headline || $[3] !== market) {
    const t = getT(getLanguageForMarket(market), {
      category: categoryCatalog
    });
    const currentHeadline = headline ?? t("category.shopByCategory");
    T1 = ContentBlock;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = cn("mt-8 mb-4 flex !max-w-6xl flex-col justify-center py-10 lg:py-6", barlowCondensed.className);
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    const t8 = `${currentHeadline} carousel`;
    let t9;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = {
        base: 1.5,
        sm: 2,
        md: 4
      };
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    let t10;
    if ($[15] !== categories || $[16] !== market) {
      t10 = categories?.map((category, i) => <div key={`${category?.id}-${i}-category-card`} className="w-full"><SingleCategoryCard category={category} market={market} /></div>);
      $[15] = categories;
      $[16] = market;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    let t11;
    if ($[18] !== t10 || $[19] !== t8) {
      t11 = <div className="relative px-0 py-8 sm:px-8"><CssCarousel ariaLabel={t8} showArrows={true} roundedArrows={true} showScroll={true} showDots={false} slidesPerView={t9}>{t10}</CssCarousel></div>;
      $[18] = t10;
      $[19] = t8;
      $[20] = t11;
    } else {
      t11 = $[20];
    }
    t7 = <div className="mx-6 xl:mx-0"><ArrowTitle headline={currentHeadline} />{t11}</div>;
    T0 = Button;
    t1 = "link";
    t2 = `/${market}/category` as Route;
    t3 = false;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = cn("mx-auto w-full max-w-[360px] py-6! uppercase", roboto.className);
      $[21] = t4;
    } else {
      t4 = $[21];
    }
    t5 = ctaText ?? t("category.viewAllCategories");
    $[0] = categories;
    $[1] = ctaText;
    $[2] = headline;
    $[3] = market;
    $[4] = T0;
    $[5] = T1;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    T0 = $[4];
    T1 = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
  }
  let t8;
  if ($[22] !== T0 || $[23] !== t1 || $[24] !== t2 || $[25] !== t3 || $[26] !== t4 || $[27] !== t5) {
    t8 = <T0 as={t1} href={t2} prefetch={t3} className={t4}>{t5}</T0>;
    $[22] = T0;
    $[23] = t1;
    $[24] = t2;
    $[25] = t3;
    $[26] = t4;
    $[27] = t5;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== T1 || $[30] !== t6 || $[31] !== t7 || $[32] !== t8) {
    t9 = <T1 className={t6}>{t7}{t8}</T1>;
    $[29] = T1;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  return t9;
};